import EHEADER from "../constants/headerRequest.enum";
import { utmsRanges } from "src/constants/kpi.constant";

const baseUrl = process.env.REACT_APP_BASE_API_URL;

let axiosRequestConfig = {
  baseURL: baseUrl,
  headers: {
    Accept: "application/json;utf-8",
  },
};

export const setRequestConfig = (config) => {
  let newHeader = config.headers;
  if (newHeader) {
    newHeader = {
      ...axiosRequestConfig.headers,
      ...config.headers,
    };
  }
  axiosRequestConfig = { ...axiosRequestConfig, ...config };

  return { ...axiosRequestConfig, ...config };
};

export const setMediaTypeConfig = (config) => {
  switch (config) {
    case EHEADER.HEADER_JSON:
      setRequestConfig({
        headers: { "Content-Type": "application/json;utf-8" },
      });
      break;
    case EHEADER.HEADER_MULTIPART:
      setRequestConfig({
        headers: { "Content-Type": "multipart/form-data;utf-8" },
      });
      break;
    case EHEADER.HEADER_URL_ENCODE:
      setRequestConfig({
        headers: { "Content-Type": "application/x-www-form-urlencoded;utf-8" },
      });
      break;
    default:
      setRequestConfig({
        headers: { "Content-Type": "application/json;utf-8" },
      });
      break;
  }
};

export function isLogin() {
  const profileStr = localStorage.getItem("plano-profile");
  const tokenStr = localStorage.getItem("plano-jwt");
  if (profileStr && profileStr.length > 0 && tokenStr && tokenStr.length > 0) {
    return true;
  }

  return false;
}

export const getToken = () => {
  try {
    return localStorage.getItem("plano-jwt");
  } catch (err) {
    return "";
  }
};

export const setToken = (token) => {
  localStorage.setItem("plano-jwt", token);
};

export const getProfile = () => {
  try {
    return localStorage.getItem("plano-profile");
  } catch (err) {
    return "";
  }
};

export const setProfile = (profile) => {
  localStorage.setItem("plano-profile", JSON.stringify(profile));
};

export const removeToken = () => {
  localStorage.removeItem("plano-jwt");
};

export const removeProfile = () => {
  localStorage.removeItem("plano-profile");
};

export const onPress = (event) => {
  let mainKey = event.key;
  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const keys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  if (persianNumbers.includes(mainKey)) {
    mainKey = persianNumbers.indexOf(mainKey).toString();
  }
  if (!keys.includes(mainKey)) {
    event.preventDefault();
  } else {
    // const englishNumber = persianNumbers.includes(mainKey)
    //   ? persianNumbers.indexOf(mainKey)
    //   : mainKey;
    return mainKey;
  }
  return false;
};

export const fixNumbers = (event) => {
  const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  let str = event.value;
  if (typeof str === "string") {
    for (let i = 0; i < 10; i += 1) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }

  return str;
};

export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export const pickTextColorBasedOnBgColor = (
  bgColor = "#ffffff",
  lightColor = "#ffffff",
  darkColor = "#000000"
) => {
  const color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB
  const uicolors = [r / 255, g / 255, b / 255];
  const c = uicolors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92;
    }
    // eslint-disable-next-line no-restricted-properties
    return Math.pow((col + 0.055) / 1.055, 2.4);
  });
  const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  return L > 0.179 ? darkColor : lightColor;
};

export function makeFullScreen() {
  var divObj = document.getElementById("camera-wrapper");

  var isInFullScreen =
    (document.fullscreenElement && document.fullscreenElement !== null) ||
    (document.webkitFullscreenElement &&
      document.webkitFullscreenElement !== null) ||
    (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
    (document.msFullscreenElement && document.msFullscreenElement !== null);

  //Use the specification method before using prefixed versions
  if (!isInFullScreen) {
    if (divObj.requestFullscreen) {
      divObj.requestFullscreen();
    } else if (divObj.msRequestFullscreen) {
      divObj.msRequestFullscreen();
    } else if (divObj.mozRequestFullScreen) {
      divObj.mozRequestFullScreen();
    } else if (divObj.webkitRequestFullscreen) {
      divObj.webkitRequestFullscreen();
    } else {
      console.log("Fullscreen API is not supported");
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else {
      console.log("exit fullscreen, doesnt work");
    }
  }
}

export function paramsToObject(entries) {
  const result = {};
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
}

export const groupParamsByKey = (params) =>
  [...params.entries()].reduce((acc, tuple) => {
    // getting the key and value from each tuple
    const [key, val] = tuple;
    debugger;
    if (acc.hasOwnProperty(key)) {
      // if the current key is already an array, we'll add the value to it
      if (Array.isArray(acc[key])) {
        acc[key] = [...acc[key], val];
      } else {
        // if it's not an array, but contains a value, we'll convert it into an array
        // and add the current value to it
        acc[key] = [acc[key], val];
      }
    } else {
      // plain assignment if no special case is present
      acc[key] = val;
    }

    return acc;
  }, {});

export function eraseCookieFromAllPaths(name) {
  // This function will attempt to remove a cookie from all paths.
  var pathBits = window.location.pathname.split("/");
  var pathCurrent = " path=";

  // do a simple pathless delete first.
  document.cookie = name + "=; expires=Thu, 01-Jan-1970 00:00:01 GMT;";

  for (var i = 0; i < pathBits.length; i++) {
    pathCurrent += (pathCurrent.substr(-1) !== "/" ? "/" : "") + pathBits[i];
    document.cookie =
      name + "=; expires=Thu, 01-Jan-1970 00:00:01 GMT;" + pathCurrent + ";";
  }
}

function addAlpha(color, opacity) {
  // coerce values so ti is between 0 and 1.
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}

export function hexToRGB(hex, alfa = 1) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    addAlpha(hex, alfa)
  );

  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
        parseInt(result[4], 16),
      ]
    : null;
}

export function fetchRGBFromRange(v) {
  const l = utmsRanges.find((l) => v > l.max && v < l.min);
  try {
    let color = l.color;
    return color;
  } catch (e) {
    return [0, 0, 0];
  }
}

//  ============================================================================================================

// check if an element exists in array using a comparer function
// comparer : function(currentElement)
// eslint-disable-next-line
Array.prototype.inArray = function (comparer) {
  for (var i = 0; i < this.length; i++) {
    if (comparer(this[i])) return true;
  }
  return false;
};

// adds an element to the array if it does not already exist using a comparer
// function
// eslint-disable-next-line
Array.prototype.pushIfNotExist = function (element, comparer) {
  if (!this.inArray(comparer)) {
    this.push(element);
  }
};
